import React, { ChangeEvent, useCallback, useState } from 'react'
import { checkErrors, checkErrorsWhenSubmit, ValuesForm } from '../../../../utils/verifications/Forms'
import { MyYup } from '../../../../utils/verifications/myYup'
import GeneralInputTitle from '../../../UIcomponents/GeneralInputTitle/GeneralInputTitle'
import InputList from '../../../UIcomponents/InputList/InputList'
import ItemListNotification from './ItemListNotification/ItemListNotification'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import "./CreateScheduleNotificationForm.css"
import { faClock } from '@fortawesome/free-regular-svg-icons'
import ConModalSelectScheduleNotification from '../ConModalSelectScheduleNotification/ConModalSelectScheduleNotification'
import { Schedule, ScheduleNotification, setUpdateScheduleNotificationReducer, UpdateScheduleNotificationsThunk } from '../../../../redux/slices/components/ScheduleNotifications/scheduleNotificationsSlice'
import { BodyScheduleNotifications, createScheduleNotification, updateScheduleNotification, UpdateScheduleNotificationBody } from '../../../../utils/requestsUtils/functionsRequests/user/userFunctions'
import LoadingSpinner from '../../../LoadingSpinner'
import ConModalResumeScheduleNotification from '../ConModalResumeScheduleNotification/ConModalResumeScheduleNotification'
import moment from 'moment'
import { useTranslation } from 'react-i18next'
import { useAppDispatch } from '../../../../redux/store/store'
import useGetScheduleText, { getScheduleFrecuency } from '../../../hooks/useGetScheduleText/useGetScheduleText'

type SubjectNotificationId = "News" | "Reminders" | "Announcement" | "Security" | "Other"
export type SubjectNotification = {
    id:     SubjectNotificationId
    text:   string
}

export type DeviceNotificationId = "All" | "Just_Desktop" | "Just_App"
export type DeviceNotification = {
    id:     DeviceNotificationId
    text:   string
}

type TopicNotificationId = "general-topic" | "gim-topic" | "gimmer-topic"
export type TopicNotification = {
    id:         TopicNotificationId
    text:       string
    className:  string
}

export type FrecuencyNotificationId = "One_time" | "Every_day" | "Every_week" | "Every_month"
export type FrecuencyNotification = {
    id:         FrecuencyNotificationId
    text:       string
}

export type ScheduleFrecuency = {
    id: "One_time"
    utcDate: string
    utcHour: string
} | {
    id: "Every_day"
    utcHour: string
} | {
    id: "Every_week"
    weekDay: string
    utcHour: string
} | {
    id: "Every_month"
    utcDate: string
    utcHour: string
}



type CreateScheduleNotificationFormProps = {
    type: "Edit",
    scheduleNotification: ScheduleNotification
} | { type: "Create" }

const CreateScheduleNotificationForm = (props: CreateScheduleNotificationFormProps) => {

    const { t, i18n } = useTranslation()
    const dispatch = useAppDispatch()

    const subjects: SubjectNotification[] = [
        { id: "News", text: t(`Notifications:schedule:subject:${"News"}`) },
        { id: "Reminders", text: t(`Notifications:schedule:subject:${"Reminders"}`) },
        { id: "Announcement", text: t(`Notifications:schedule:subject:${"Announcement"}`) },
        { id: "Security", text: t(`Notifications:schedule:subject:${"Security"}`) },
        { id: "Other", text: t(`Notifications:schedule:subject:${"Other"}`) },
    ]
    const [subject, setSubject] = useState<SubjectNotification>(props.type === "Create" ? subjects[0] : (subjects.find(s => s.id === props.scheduleNotification.subject) ?? subjects[0]))

    const devices: DeviceNotification[] = [
        { id: "All", text: t(`Notifications:schedule:device:${"All"}`) },
        { id: "Just_Desktop", text: t(`Notifications:schedule:device:${"Just_Desktop"}`) },
        { id: "Just_App", text: t(`Notifications:schedule:device:${"Just_App"}`) },
    ]
    const [device, setDevice] = useState<DeviceNotification>(props.type === "Create" ? devices[0] : (devices.find(s => s.id === props.scheduleNotification.device) ?? devices[0]))

    const topics: TopicNotification[] = [
        { id: "general-topic", text: t(`Notifications:schedule:topic:${"general-topic"}`), className: "" },
        { id: "gim-topic", text: t(`Notifications:schedule:topic:${"gim-topic"}`), className: "color-gim" },
        { id: "gimmer-topic", text: t(`Notifications:schedule:topic:${"gimmer-topic"}`), className: "color-gimmer" },
    ]
    const [topic, setTopic] = useState<TopicNotification>(props.type === "Create" ? topics[0] : (topics.find(s => s.id === props.scheduleNotification.topic) ?? topics[0]))


    const frecuencies: FrecuencyNotification[] = [
        { id: "One_time", text: t(`Notifications:schedule:frecuency:${"One_time"}`),  },
        { id: "Every_day", text: t(`Notifications:schedule:frecuency:${"Every_day"}`), },
        { id: "Every_week", text: t(`Notifications:schedule:frecuency:${"Every_week"}`), },
        { id: "Every_month", text: t(`Notifications:schedule:frecuency:${"Every_month"}`),  },
    ]
    const [frecuency, setFrecuency] = useState<FrecuencyNotification>(props.type === "Create" ? frecuencies[0] : (frecuencies.find(s => s.id === props.scheduleNotification.frecuency) ?? frecuencies[0]))

    const [showModal, setShowModal] = useState(false)
    const [showModalResume, setShowModalResume] = useState(false)

    const [loading, setLoading] = useState(false)

    const [inputValues, setInputValues] = useState<ValuesForm>({
        title: { error: "", value: props.type === "Create" ? "" : props.scheduleNotification.title, touched: false, checkValue: (x: string | number, dv?: boolean) => new MyYup(x, i18n.language, dv).isRequired().isString().AllValidCharacters()},
        bodyNotif: { error: "", value: props.type === "Create" ? "" : props.scheduleNotification.bodyNotif, touched: false, checkValue: (x: string | number, dv?: boolean) => new MyYup(x, i18n.language, dv).isString().AllValidCharacters()},
    })

    let initialSchedule: ScheduleFrecuency | undefined = undefined

    if(props.type === "Edit"){
        initialSchedule = getScheduleFrecuency(props.scheduleNotification.frecuency, props.scheduleNotification.schedule)
    } 

    const [schedule, setSchedule] = useState<ScheduleFrecuency | undefined>(initialSchedule)

    const { alreadyExecutedOneTime } = useGetScheduleText(
        props.type === "Create"  
        ? { type: "NOT_SCHEDULE"}
        : (schedule ? { type: "ScheduleFrecuency", frecuencyId: props.scheduleNotification.frecuency, schedule: schedule } : { type: "NOT_SCHEDULE"})
    )

    const onChangeValueInput = (newEvent: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        checkErrors(newEvent, inputValues, setInputValues)
    }

    const onChangeFocusInput = (name: string) => {
        setInputValues({...inputValues, [name]: {...inputValues[name], touched: true}}) 
    }

    const onChangeSubject = (item: SubjectNotification) => {
        setSubject(item)
    }

    const onChangeDevice = (item: DeviceNotification) => {
        setDevice(item)
    }

    const onChangeTopic = (item: TopicNotification) => {
        setTopic(item)
    }

    const onChangeFrecuency = (item: FrecuencyNotification) => {
        setFrecuency(item)
        setSchedule(undefined)
    }

    const onShowModal = useCallback(
        () => {
            setShowModal(true)
        },
        [],
    )

    const onCloseModal = useCallback(
        () => {
            setShowModal(false)
        },
        [],
    )


    const onShowResumeModal = useCallback(
        () => {
            setShowModalResume(true)
        },
        [],
    )

    const onCloseResumeModal = useCallback(
        () => {
            setShowModalResume(false)
        },
        [],
    )
    
    const onSetScheduleNotification = useCallback(
        (schedule: ScheduleFrecuency) => {
            setSchedule(schedule)
        },
        [],
    )

    const onResume = () => {

        
        let existsError = false;
        for(const nameInput in inputValues){
            if(checkErrorsWhenSubmit(nameInput, inputValues))
                existsError = true
        }
        setInputValues({...inputValues})

        if(existsError)
            return

        if(!schedule || !subject || !device || !topic || !frecuency)
            return

        onShowResumeModal()

    }


    const getScheduleFormatted = (): Schedule => {
        if(!schedule){
            throw(`You must select an hour`)
        }
        const localHour = moment(schedule.utcHour).hour()
        
        if(schedule.id === "One_time"){
            return {
                minutes: moment(schedule.utcHour).utc().minutes(),
                hour: moment(schedule.utcHour).utc().hour(),
                dayOfMonth: moment.utc(schedule.utcDate).local().hour(localHour).utc().date(),
                dayOfWeek: "?",
                month: moment(schedule.utcHour).utc().month() + 1,
                year: moment(schedule.utcHour).utc().year(),
            }
        }else if(schedule.id === "Every_day"){
            return {
                minutes: moment(schedule.utcHour).utc().minutes(),
                hour: moment(schedule.utcHour).utc().hour(),
                dayOfMonth: "*",
                dayOfWeek: "?",
                month: "*",
                year: "*",
            }
        }else if(schedule.id === "Every_week"){
            return {
                minutes: moment(schedule.utcHour).utc().minutes(),
                hour: moment(schedule.utcHour).utc().hour(),
                dayOfMonth: "?",
                dayOfWeek: schedule.weekDay,
                month: "*",
                year: "*",
            }
        }else{
            return {
                minutes: moment(schedule.utcHour).utc().minutes(),
                hour: moment(schedule.utcHour).utc().hour(),
                dayOfMonth: moment.utc(schedule.utcDate).local().hour(localHour).utc().date(),
                dayOfWeek: "?",
                month: "*",
                year: "*",
            }
        }
    }

    const onSubmit = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        // || alreadyExecutedOneTime
        e.preventDefault()
        console.log("alreadyExecutedOneTime", alreadyExecutedOneTime)
        if(!schedule || !subject || !device || !topic || !frecuency || alreadyExecutedOneTime)
            return

        
        try {
            const scheduleFormatted = getScheduleFormatted()
            console.log("scheduleFormatted", scheduleFormatted)

            const scheduleNotification: BodyScheduleNotifications = {
                title:          inputValues["title"].value,
                bodyNotif:      inputValues["bodyNotif"].value,
                topic:          topic.id,
                schedule:       scheduleFormatted,
                subject:        subject.id,
                frecuency:      frecuency.id,
                device:         device.id
            }

            
            if(props.type === "Create"){
                setLoading(true)
                createScheduleNotification(scheduleNotification)
                .then(() => {
                    onCloseResumeModal()
                }).catch(() => {
                    alert("Error")
                }).finally(() => {
                    setLoading(false)
                })
            }else{


                const body: UpdateScheduleNotificationBody = {
                    title:                    inputValues["title"].value,
                    bodyNotif:                inputValues["bodyNotif"].value,
                    topic:                    topic.id,
                    subject:                  subject.id,
                    schedule:                 scheduleFormatted,
                    frecuency:                frecuency.id,
                    device:                   device.id
                }

                setLoading(true)
                updateScheduleNotification(props.scheduleNotification.id, scheduleNotification)
                .then(() => {
                    onCloseResumeModal()
                    dispatch( setUpdateScheduleNotificationReducer({ id: props.scheduleNotification.id, body }) )
                }).catch(() => {
                    alert("Error")
                }).finally(() => {
                    setLoading(false)
                })

                
            }
            
        } catch (error) {
            
            setLoading(false)
        }


    }

    return (
        <div className="">

            <p className="fs-14 mb-8 mt-10">
                {t("Notifications:schedule:index:label_01")}
            </p>

            <div className="padding-to-show-error">
                <InputList 
                    text={subjects.find(s => s.id === subject.id)?.text ?? ""}  
                    width={"16rem"}
                    fontSize="fs-11"
                    heightList="13rem"
                    height="3.4rem"
                >
                    {
                        subjects.filter(i => i.id !== subject.id).map((notif: SubjectNotification) => {
                            return(
                                <ItemListNotification 
                                    key={notif.id}
                                    item={notif}
                                    text={notif.text}
                                    onSelect={onChangeSubject}
                                />
                            )
                        })
                    }
                </InputList>
            </div>

            <p className="fs-12 mb-4 fw-600 mt-20">
                {t("Notifications:schedule:index:label_02")}
            </p>
            <GeneralInputTitle 
                title={t("Notifications:schedule:index:label_03") ?? ""}
                name={"title"}
                value={inputValues["title"].value}
                onChange={onChangeValueInput}
                onFocus={onChangeFocusInput}
                placeholder={t("Notifications:schedule:index:label_04")}
                error={inputValues["title"].error}
                width="100%"
                hideTitle={true}
                titleAbove={true}
            />

            <p className="fs-12 mb-4 mt-10">
                {t("Notifications:schedule:index:label_05")}
            </p>
            <GeneralInputTitle 
                title={`Message`}
                name={"bodyNotif"}
                value={inputValues["bodyNotif"].value}
                onChange={onChangeValueInput}
                onFocus={onChangeFocusInput}
                placeholder={t("Notifications:schedule:index:label_06")}
                error={inputValues["bodyNotif"].error}
                width="100%"
                hideTitle={true}
                titleAbove={true}
                textArea={{ height: "6rem" }}
            />


            <div className="flex">
                
                <div className="mr-20">
                    <p className="fs-14 mb-8 mt-10">
                        {t("Notifications:schedule:index:label_07")}
                    </p>
                    <div className="padding-to-show-error">
                        <InputList 
                            text={devices.find(s => s.id === device.id)?.text ?? ""}  
                            width={"13rem"}
                            fontSize="fs-11"
                            heightList="7rem"
                            height="3.4rem"
                        >
                            {
                                devices.filter(i => i.id !== device.id).map((notif: DeviceNotification) => {
                                    return(
                                        <ItemListNotification 
                                            key={notif.id}
                                            item={notif}
                                            text={notif.text}
                                            onSelect={onChangeDevice}
                                        />
                                    )
                                })
                            }
                        </InputList>
                    </div>
                </div>

                <div className="mr-30">
                    <p className="fs-14 mb-8 mt-10">
                        {t("Notifications:schedule:index:label_08")}
                    </p>
                    <div className="padding-to-show-error">
                        <InputList 
                            text={topics.find(s => s.id === topic.id)?.text ?? ""}  
                            width={"13rem"}
                            fontSize="fs-11"
                            heightList="7rem"
                            height="3.4rem"
                        >
                            {
                                topics.filter(i => i.id !== topic.id).map((notif: TopicNotification) => {
                                    return(
                                        <ItemListNotification 
                                            key={notif.id}
                                            item={notif}
                                            text={notif.text}
                                            onSelect={onChangeTopic}
                                            className={notif.className}
                                        />
                                    )
                                })
                            }
                        </InputList>
                    </div>
                </div>

            </div>

            <div className="line-gray-help mt-18 mb-20" />

            <div className="flex flex-jc-sb flex-ai-end">
                
                <div className="mr-30">
                    <p className="fs-14 mb-8">
                        {t("Notifications:schedule:index:label_09")}
                    </p>
                    <div className="padding-to-show-error">
                        <InputList 
                            text={frecuencies.find(s => s.id === frecuency.id)?.text ?? ""}  
                            width={"16rem"}
                            fontSize="fs-11"
                            heightList="10rem"
                            height="3.4rem"
                        >
                            {
                                frecuencies.filter(i => i.id !== frecuency.id).map((notif) => {
                                    return(
                                        <ItemListNotification 
                                            key={notif.id}
                                            item={notif}
                                            text={notif.text}
                                            onSelect={onChangeFrecuency}
                                        />
                                    )
                                })
                            }
                        </InputList>
                    </div>
                </div>

                <div className="flex flex-jc-end mb-12">
                    <button
                        onClick={onShowModal}
                    >
                        <FontAwesomeIcon 
                            icon={faClock}
                            className={`fs-28 mr-20 ${(schedule && !alreadyExecutedOneTime) ? "c-black" : "color-error"}`}
                        />
                    </button>

                    <button
                        onClick={onResume}
                        className="validate-btn-notif"
                    >
                        {t("Notifications:schedule:index:label_10")}
                    </button>
                </div>

            </div>

            {
                showModal
                ? 
                <ConModalSelectScheduleNotification 
                    frecuencyId={frecuency.id}
                    onCloseModal={onCloseModal}
                    onSet={onSetScheduleNotification}
                    //schedule={schedule}
                />
                : null
            }

            {
                (showModalResume && frecuency && subject && device && schedule)
                ? 
                <ConModalResumeScheduleNotification
                    frecuency={frecuency}
                    subject={subject}
                    topic={topic}
                    device={device}
                    schedule={schedule}
                    title={inputValues["title"].value}
                    bodyNotif={inputValues["bodyNotif"].value}
                    onSubmit={onSubmit}
                    onCloseModal={onCloseResumeModal}
                />
                : null
            }

            { loading ? <LoadingSpinner fullPage={true} /> : null}

        </div>
    )
}

export default React.memo( CreateScheduleNotificationForm )